import styled from 'styled-components';

export const Wrapper = styled.main`
  flex-grow: 1;
  padding: 0 50px;
`;
